export default function getInitials(...words) {
  return words.map((word) => {
    return word[0];
  }).join('');
}
